import { createRoot } from 'react-dom/client';
import { MarketingHeader } from './marketingHeader.js';
import { MarketingProjectCards } from './MarketingProjectCards.js';
import { MarketingImpact } from './marketingImpact.js';
import { MarketingTeacherCards } from './MarketingTeacherCards.js';
import { ViewTrackingContext } from '../common/ViewTrackingContext.ts';
import { MarketingFAQ } from './MarketingFAQ.js';

/* global challengeId numProjects */

const trackSectionView = (sectionName) => {
    dcAnalytics.track('Marketing Page Viewed', {sectionName, challengeId})
}

const MarketingPage = ({contextData, projects, teachers}) => {
    return (
        <div style={{ textAlign: 'center' }}>
            <ViewTrackingContext.Provider value={trackSectionView}>
                <div className="top-of-the-fold">
                    <MarketingHeader data={contextData}/>
                    <div className="card-container">
                        {contextData.teacherCards ?
                        <MarketingTeacherCards teachers={teachers} data={contextData}/> : null}
                    </div>
                </div>
                {contextData.projectCards ? <MarketingProjectCards projects={projects} data={contextData}
                                                                   numProjects={numProjects}/> : null}
                {contextData.impact ? <MarketingImpact state={contextData.impactState}/> : null}
                {contextData.faqList !== null && contextData.faqList.length !== 0 ?
                    <MarketingFAQ faqs={contextData.faqList}/> : null}
            </ViewTrackingContext.Provider>
        </div>
    )
}

$(() => {
    const contentData = JSON.parse(document.getElementById('js-marketing-data').innerText);
    const serializedProjects = JSON.parse(document.getElementById('js-marketing-projects').innerText);
    const serializedTeachers = JSON.parse(document.getElementById('js-marketing-teachers').innerText);

    const root = createRoot(document.getElementById('marketing-content'));

    root.render(
        <MarketingPage contextData={contentData} projects={serializedProjects} teachers={serializedTeachers}/>
    );
});
